import React from 'react'

export default class UserAccountTypeSelect extends React.Component {
    constructor(props) {
        super(props);

        var colSize = 2;
        var title = "Select a user account type:";
        var sortID = "property-manager";
        var styles;

        if(this.props.columnSize !== undefined)
        {
            colSize = this.props.columnSize;
        }
        if(this.props.title !== undefined)
        {
            title = this.props.title;
        }
        if(this.props.sortID !== undefined || this.props.sortID != "")
        {
            sortID = this.props.sortID;
        }
        if(this.props.padding !== undefined)
        {
            styles = {
                padding: this.props.padding
            }
        }

        this.options = {
            columnSize: "col-sm-" + colSize,
            title: title,
            sortID: sortID,
            styles: styles
        }

    }

    componentDidMount() {
    }

    componentWillUpdate(nextProps, nextState) {
        if(nextProps.sortID === undefined || nextProps.sortID == "") {
            this.options.sortID = "month";
        } else {
            this.options.sortID = nextProps.sortID;
        }
    }

    render(){
        const options = this.options;
        return (
            <div class={options.columnSize} style={options.styles}>
                <small>{options.title}</small>
                <select class="form-control" value={options.sortID} onChange={this.props.onChange}>
                    <option value="property-manager">Property Manager</option>
                    <option value="contractor">Contractor</option>
                    {/* <option value="owner">Owner</option> */}
                </select>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/helpers/General/UserAccountTypeSelect.jsx